
import React, {
  memo,
  useRef,
  useState,
  useEffect } from
'react';

import uuidv4 from 'uuid/v4';
import { Button, Text, FormModal } from '../../../../../ui-kit';

import AddToProjectModal from '../../../../AddToProjectModal/components/AddToProjectModal';


















function StockAssetModal({
  assetModalData: {
    id: externalId,
    source,
    duration,
    assetType,
    previewUrl,
    description,
    aspectRatio
  },
  assetModalData,
  assetModalType,
  toggleAssetModal,
  getFilteredVideos,
  updateVideoAtomic,
  handleCardOptionClick,
  closeAddAssetToPoject,
  createOrgStockAssets
}) {
  const loadingTimeoutRef = useRef();

  const [projectData, setProjectData] = useState([]);
  const [projectsCount, setProjectsCount] = useState(0);
  const [totalProjectsCount, setTotalProjectsCount] = useState(0);

  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(false);
  const [loadingSuccess, setLoadingSuccess] = useState(false);

  const getProjects = async ({
    query = '',
    offset = 0,
    limit = 20
  }) => {
    const { data = {}, error } = await getFilteredVideos({
      limit,
      offset,
      sortBy: 'ALL',
      USER: ['ALL'],
      isArchived: false,
      searchTerm: query
    });

    if (error || !data) {
      return void setLoadingError(true);
    }

    const tempProjects = [];
    const { videos, count, totalVideosCount } = data.getFilteredVideos;

    for (const video of videos) {
      const { videoId, name, readableId, requestedExtras } = video;

      const videoProject = {
        videoId,
        title: name,
        requestedExtras,
        projectId: readableId,
        projectThumb: {
          THUMBNAIL: {
            type: 'THUMBNAIL',
            sourceUrl: ''
          }
        }
      };

      tempProjects.push(videoProject);
    }

    setProjectsCount(count);
    setTotalProjectsCount(totalVideosCount);

    if (offset === 0) {
      setProjectData(tempProjects);
    } else {
      setProjectData(projectData.concat(tempProjects));
    }
  };

  useEffect(() => {
    (async () => {
      await getProjects({});
    })();
  }, [assetModalType === 'add']);

  useEffect(() => setLoading(false), [loadingError]);

  useEffect(() => () => clearTimeout(loadingTimeoutRef.current), []);

  const addAssetToProject = () => {
    const option = {
      asset: assetModalData,
      type: 'add'
    };
    handleCardOptionClick(option);
  };

  const updateRequestedExtras = async (videoId, requestedVideoExtras) => {
    const { data = {}, error } = await updateVideoAtomic({
      inputs: {
        type: 'ADD',
        fieldName: 'requestedExtras',
        value: requestedVideoExtras,
        itemIds: [requestedVideoExtras]
      },
      videoId
    });

    if (error || !data) {
      return void setLoadingError(true);
    }
  };

  const addStockAssetToRequestedExtras = async (selectedVideoId, assetId) => {
    projectData.forEach(async ({
      videoId,
      requestedExtras
    }) => {
      if (videoId === selectedVideoId) {
        const videoRequestedExtras = requestedExtras !== '{}' ? JSON.parse(requestedExtras) : { STOCK_ASSETS: [] };
        videoRequestedExtras.STOCK_ASSETS.push({
          value: assetId
        });
        updateRequestedExtras(selectedVideoId, JSON.stringify(videoRequestedExtras));
      }
    });
  };

  const createStockAssetClip = async (videoId, newStockAssetRecordId) => {
    const insertableClip = {
      clipId: uuidv4(),
      assetId: newStockAssetRecordId,
      isEmpty: false,
      startTime: 0,
      clipStartTime: 0,
      isImage: false,
      duration: 0,
      originalDuration: 0,
      layerIndex: 1
    };

    const { data: clipsData, error } = await updateVideoAtomic({
      inputs: {
        type: 'ADD',
        fieldName: 'clips',
        value: [insertableClip]
      },
      videoId
    });

    if (error || !clipsData) {
      return void setLoadingError(true);
    }
  };

  const addNewStockAssetIdToProjects = async (selectedVideoIds, newStockAssetRecordId) => {
    const videoIds = [];
    await selectedVideoIds.forEach((videos) => videoIds.push(videos.key));

    videoIds.forEach(async (videoId) => {
      const { data = {}, error } = await updateVideoAtomic({
        inputs: {
          type: 'ADD',
          fieldName: 'assetIds',
          value: [newStockAssetRecordId],
          itemIds: [newStockAssetRecordId]
        },
        videoId
      });

      if (error || !data) {
        setLoadingError(true);
      }

      await addStockAssetToRequestedExtras(videoId, newStockAssetRecordId);
      await createStockAssetClip(videoId, newStockAssetRecordId);
    });

    setLoadingSuccess(true);

    // timer to give user moment to see success status if api response is too fast
    loadingTimeoutRef.current = setTimeout(() => {
      closeAddAssetToPoject();
    }, 2000);
  };

  const onSave = async (selectedProjectIds) => {
    setLoading(true);

    const { data: { createStockAssetRecords } = {}, error } = await createOrgStockAssets({
      assets: [{
        externalId,
        source,
        mediaType: assetType
      }]
    });

    if (error || !createStockAssetRecords) {
      return void setLoadingError(true);
    }

    const newStockAssetRecordId = createStockAssetRecords[0].assetId;
    addNewStockAssetIdToProjects(selectedProjectIds, newStockAssetRecordId);
  };

  return (
    <div className="stock-asset-modal" style={{ zIndex: 110 }}>
      {loadingError && <></>}
      {assetModalType === 'details' ?
      <FormModal
        title={null}
        subtitle={null}
        hideFooter
        key="stock-asset-modal"
        visible
        showCancelBtn={false}
        onClose={() => toggleAssetModal(true)}>

          <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 35 }}>
            <div style={{ width: '65%' }}>
              <video style={{ width: '95%' }} controls>
                <source src={previewUrl} type="video/mp4" />
                <track src="" kind="captions" srcLang="" label="" />
              </video>
            </div>
            <div style={{ width: '35%', minHeight: 300 }}>
              <Text heading3>{description}</Text>
              <br />
              <Text>
                Asset ID:
                {' '}
                {externalId}
                <br />
                File Type:
                {' '}
                {assetType}
                <br />
                {duration}
                s |
                {' '}
                {aspectRatio}
              </Text>
              <hr style={{ marginTop: 20, marginBottom: 30 }} />

              <Button style={{ width: '100%' }} onClick={() => addAssetToProject()}>Add to project</Button>
            </div>
          </div>
        </FormModal> :

      <AddToProjectModal
        visible
        onSave={onSave}
        loading={loading}
        projects={projectData}
        getProjects={getProjects}
        setProjects={setProjectData}
        projectsCount={projectsCount}
        selectedAsset={assetModalData}
        onClose={closeAddAssetToPoject}
        loadingSuccess={loadingSuccess}
        totalProjectsCount={totalProjectsCount} />}


    </div>);

}

export default memo(StockAssetModal);